module.exports = "/1/0-viet-chuong-trinh-dau-tien/index.html.a512d65564a3c061c7f754360a019b46.json"


/*****************
 ** WEBPACK FOOTER
 ** ./content/generated/29504.md
 ** module id = 528
 ** module chunks = 0
 **/